import { render, staticRenderFns } from "./PastItemTable.vue?vue&type=template&id=627aaad8&scoped=true&"
import script from "./PastItemTable.vue?vue&type=script&lang=ts&"
export * from "./PastItemTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627aaad8",
  null
  
)

export default component.exports